/* Add native details support to the existing drawer's keyboard loop. */
(() => {
  const bind = () => {
    const drawer = document.getElementById('nav-drawer-header');
    if (!drawer || !drawer.classList.contains('facts-menu-v5') || drawer.dataset.fsmBound) return;
    drawer.dataset.fsmBound = 'true';
    drawer.addEventListener('keydown', event => {
      if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const focusable = [...drawer.querySelectorAll('a[href],button,summary')].filter(el => {
        const details = el.closest('details');
        return !el.disabled && el.getClientRects().length && (!details || details.open || el.tagName === 'SUMMARY');
      });
      const first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }, true);
    window.addEventListener('resize', () => {
      if (window.innerWidth >= 977 && drawer.classList.contains('is-open')) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:toggle', {detail:{trigger:drawer.querySelector('.fsm-close')}}));
      }
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
